import React from 'react';
import { Card, Row, Col, Form, Input, InputNumber, Button, Space } from 'antd';
import { Navigate, useParams } from 'react-router-dom'
import axios from '../../services/axios'

const layout = {
  labelCol: { xs: { span: 24 }, sm: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
};

const validateMessages = {
  required: '${label} est obligatoire',
  types: {
    email: "${label} n'est pas un email valide",
    number: "${label} n'est pas un nombre valide",
  },
  number: {
    range: '${label} doit être compris entre ${min} et ${max}',
  },
};


const Forms = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false)
  const [editloading, setEditLoading] = React.useState(false)
  const [redirect, setRedirect] = React.useState(false)
  const [devise, setDevise] = React.useState({})
  const [libelle, setLibelle] = React.useState('')
  const [code, setCode] = React.useState('')
  const [description, setDescription] = React.useState('')
  let { id }: any = useParams()
  React.useEffect(() => {
    if (id) {
      getSingleCurrency(id)
    }

  }, [])

  const getSingleCurrency = (id: number) => {
    axios.get(`/devises/show/${id}`)
      .then(response => {
        form.setFieldsValue(response.data)
        setLoading(false)
      })
      .catch(error => {
        console.log('error not found', error);
      });
  }
  const updateDevise = (data: any[], id: number) => {
    setEditLoading(true);
    axios.post(`/devises/edit/${id}`, data)
      .then(function (response) {
        
        setRedirect(true)
        setEditLoading(false);
        form.resetFields();
      })
      .catch(function (error) {
        console.log(error);
        setEditLoading(false);
      });
  }
  const onFinish = (values: any) => {
    
    setLoading(true);

    if (id) {
      updateDevise(values, id);
    }

    axios.post('/devises/new', values)
      .then(function (response) {
        
        setRedirect(true)
        setLoading(false);
        form.resetFields();
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });

    form.resetFields();
  };
  const onReset = () => {
    form.resetFields();
  }

  return <>
    <Row justify="center">
      <Col xs={24} sm={22} md={18} lg={12} xl={12} offset={0}>
        <Card size="small" title="Ajouter une nouvelle devise"  >
          <Form {...layout}
            form={form}
            name="nest-messages"
            onFinish={onFinish}
            validateMessages={validateMessages}
            initialValues={devise}
          >
            <Form.Item name='code' label="Code" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name='libelle' label="Libelle" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item initialValue={description ? description : ''} name='description' label="Description">
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              initialValue={1}
              name='palier'
              label="Palier"
              tooltip="Nombre d'unités de cette devise que représente le taux du jour (1 par défaut, 5000 pour le FCFA)"
            >
              <InputNumber min={1} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Space>
                {
                  !id ? (
                    <Button loading={loading} type="primary" htmlType="submit">
                      Enregistrer
                    </Button>
                  ) : (
                    <Button loading={editloading} type="primary" htmlType="submit">
                      Modifier
                    </Button>
                  )
                }
                <Button htmlType="button" onClick={onReset}>
                  Annuler
            </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
    {
      redirect ? (<Navigate to="/devises/" replace />) : ''
    }
  </>;
}

export default Forms;